import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import data from "../../data/mainData.json";

class Banner2 extends Component {
    render() {

        let publicUrl = process.env.PUBLIC_URL + '/'
        let imagealt = 'image'

        return <div className="ltn__slider-area ltn__slider-3 ">
            <div style={{ height: "600px", position: "relative"}}>
            <div className="ltn__slide-one-active slick-slide-arrow-1 slick-slide-dots-1">
                {data?.banner2?.map((banner, index) => (
                    <div key={index}>
                    <div className="container">
                        <div className="slide-item-img2">
                        <img
                            src={publicUrl + banner.image_url}
                            alt={`banner-${index}`}
                            style={{ height: "500px", width: "100%", objectFit: "cover" }}
                        />
                        </div>
                    </div>
                    </div>
                ))}
                </div>

            </div>
        </div>
    }
}

export default Banner2